export default "__VITE_ASSET__Bv0Xm4$h__"